<template>
  <b-container class="p-0">
    <b-card>
      <b-row class="transaction-container">
        <b-col
          xl="auto"
          lg="12"
          md="12"
          cols="12"
          class="transaction-info-container"
        >
          <p>
            {{ transactionDateWWeekDays }}
          </p>
          <p class="price-text left">
            {{ +transactionValue | value }}
          </p>
        </b-col>
        <b-col
          v-if="cardData"
          xl="auto"
          lg="6"
          md="6"
          sm="6"
          cols="6"
          class="card-container"
        >
          <b-img
            :src="require(`@/assets/images/paymentIcons/${cardData.image}`)"
            class="mt-2"
          />
          <p class="mt-2">{{ cardData.text }}<br>
            {{ cardData ? 'Á vista' : 'Parcelado' }}
          </p>
        </b-col>

        <b-col
          xl="auto"
        >
          <div
            class="status-container"
          >
            <feather-icon
              size="40"
              class="status-item"
              :icon="status.icon"
              :style="`color: ${status.color} !important;`"
            />
            <b-alert
              class="status-item"
              :variant="status.variant"
              show
            >
              {{ status.status }}
            </b-alert>
          </div>
        </b-col>
      </b-row>

      <b-row class="customer-container mt-1 ">
        <b-col
          sm="6"
          lg="6"
          :xl=" customerName.length < 18 ? 3 : 'auto'"
        >
          <h6>Nome:</h6>
          <p class="mt-1">
            {{ customerName }}
          </p>
        </b-col>
        <b-col
          sm="6"
          lg="6"
          xl="auto"
        >
          <h6>{{ secondTitle }}:</h6>
          <p class="mt-1">
            {{ customerEmail }}
          </p>
        </b-col>
        <b-col
          v-if="customerTaxid"
          sm="6"
          lg="6"
          xl="auto"
        >
          <h6>{{ customerTaxid.length === 14 ? 'CPF' : customerTaxid.length === 18 ? 'CNPJ' : 'Documento' }}:</h6>
          <p class="mt-1">
            {{ customerTaxid | tax_id }}
          </p>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import {
  BCard,
  BContainer,
  BAlert,
  BRow,
  BCol,
  BImg,
} from 'bootstrap-vue'

import { DateTime } from 'luxon'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

import { daysWeek, cardBrandIcon, statusObject } from '@/information/detailsTransaction'

export default {
  components: {
    BAlert,
    BCard,
    BContainer,
    BRow,
    BCol,
    BImg,
    FeatherIcon,
  },
  props: {
    transactionDate: {
      type: String,
      default: () => '',
    },

    transactionValue: {
      type: String || Number,
      default: () => '',
    },

    customerName: {
      type: String,
      default: () => '',
    },

    customerEmail: {
      type: String,
      default: () => '',
    },

    customerTaxid: {
      type: String,
      default: () => '',
    },

    secondTitle: {
      type: String,
      default: () => '',
    },

    statusId: {
      type: Number,
      default: () => 1,
    },

    card: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      cardData: cardBrandIcon[this.card],
      status: {
        color: '',
        icon: '',
        variant: '',
        status: '',
      },
    }
  },

  computed: {
    transactionDateWWeekDays() {
      const date = this.transactionDate

      const weekdayTransaction = daysWeek[DateTime.fromISO(date).weekday]

      const transactionDate = DateTime.fromISO(date).toFormat('dd/MM/yyyy')
      const transactionHours = `${DateTime.fromISO(date).toFormat('HH')}h${DateTime.fromISO(date).toFormat('mm')}`

      return transactionDate.concat(', ', weekdayTransaction, ', ', transactionHours)
    },
  },

  mounted() {
    this.status = statusObject[this.statusId]
  },

  methods: {
    handleCardBrand() {
      // this.cardData = cardBrandIcon[this.cardData]
    },

    handleStatus() {
      this.status = statusObject[this.statusId]
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "@core/scss/base/components/info-card.scss";
</style>
